<template>
  <p v-if="user.type != 6">
    {{ $t("pallet_content.dont_make_legs_for_pallet") }}
    <input
      :checked="!print"
      :disabled="disabled"
      type="checkbox"
      @input="updatePrintable"
    />
  </p>
</template>

<script>
import User from "@/models/User.js";
export default {
  props: ["pallet"],
  data() {
    return {
      disabled: false,
      user: new User(this.$session.get("user")),
    };
  },
  computed: {
    print() {
      return this.pallet.printable;
    },
  },
  methods: {
    async updatePrintable() {
      this.disabled = true;
      this.pallet.printable = !this.pallet.printable;
      this.$store.commit("setLoading", true);
      await this.pallet.save();
      this.$emit("updated");
      this.disabled = false;
    },
  },
};
</script>

<style></style>
